import styled from 'styled-components';
import spacing from '../../../../styles/spacing';

export const StyledCheckboxWrapper = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledPreTitle = styled.div`
    padding: ${spacing[12]} ${spacing[12]} 0;
`;

export const StyledPrefix = styled.div`
    padding: ${spacing[12]};
`;

export const StyledSuffix = styled.div`
    padding-right: ${spacing[12]};
`;

export const StyledActionsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[4]};
`;

export const StyledMenuWrapper = styled.div`
    display: flex;
    align-items: center;
`;
